import React from 'react';

import TouristData from './TouristData';
import { 
  InsuranceParameters, 
  IInsurance, 
  SetInsurance,
  SetInsuranceParameters 
} from '../../../types';
import { DataTouristWrapper } from '../styles';

const TouristsDataList: React.FC<{
  insurance: IInsurance;
  parameters: InsuranceParameters;
  setInsurance: SetInsurance; 
  setInsuranceParameters: SetInsuranceParameters;  
}> = ({ insurance, parameters, setInsurance, setInsuranceParameters }) => {
  const { selectedTourists } = parameters || {}; 

  return (
    <DataTouristWrapper>
      {selectedTourists.map((_, index: number) => {
        return (
          <TouristData
            key={index}
            index={index}       
            insurance={insurance}     
            parameters={parameters} 
            setInsurance={setInsurance}          
            setInsuranceParameters={setInsuranceParameters}
          />
        );
      })}
    </DataTouristWrapper>
  );
};

export default TouristsDataList;
